<template>
    <svg class="wheel" viewBox="0 0 400 400" aria-hidden="true" focusable="false">
        <g class="ring">
            <!-- Painted last petal first, so a lower index sits on top of its neighbour
                 and the overlap shingles the same way the whole way round. -->
            <circle v-for="petal in petals" :key="petal.code" :cx="petal.cx" :cy="petal.cy" r="56" :fill="petal.color" />
        </g>
        <circle class="core" cx="200" cy="206" r="88" />
    </svg>
</template>

<script setup lang="ts">
/**
 * Keep rotation indeterminate: the pipeline exposes neither progress nor an archetype here. Share
 * perspectiveTypes colours and ordering with results views to preserve type identity.
 */
import { TYPE_COLORS, WHEEL_ORDER } from "~vue/pages/perspectiveTypes";

const CENTRE_X = 200;
const CENTRE_Y = 206;
const RING_RADIUS = 126;

const petals = WHEEL_ORDER.map((code, index) => {
    const angle = ((-90 + (index * 360) / WHEEL_ORDER.length) * Math.PI) / 180;
    return {
        code,
        color: TYPE_COLORS[code],
        cx: CENTRE_X + RING_RADIUS * Math.cos(angle),
        cy: CENTRE_Y + RING_RADIUS * Math.sin(angle),
    };
}).reverse();
</script>

<style scoped>
@reference "../../../css/tailwind.css";

@layer components {
    .wheel {
        @apply block w-[320px] max-w-full;
    }

    .core {
        fill: var(--color-surface-raised);
    }

    .ring {
        transform-origin: 200px 206px;
        animation:
            wheel-open 0.8s cubic-bezier(0.4, 0, 0.2, 1) both,
            wheel-turn 14s linear 0.8s infinite;
    }
}

@keyframes wheel-open {
    from {
        opacity: 0;
        transform: scale(0.34);
    }
    to {
        opacity: 1;
        transform: scale(1);
    }
}

@keyframes wheel-turn {
    to {
        transform: rotate(360deg);
    }
}

@media (prefers-reduced-motion: reduce) {
    .ring {
        animation: none;
    }
}
</style>
